import React from "react";

const Stats = () => {
  return (
    <section className="stats" aria-label="our stats">
      <div className="container">
        <ul
          className="stats-card has-bg-image"
          style={{ backgroundImage: "url('./assets/images/stats-bg.jpg')" }}
        >
          <li>
            <p className="card-text">
              <span className="h1">10000+</span>
              <span className="span">Successful Rides</span>
            </p>
          </li>

          <li>
            <p className="card-text">
              <span className="h1">5000+</span>
              <span className="span">Happy Passengers</span>
            </p>
          </li>

          <li>
            <p className="card-text">
              <span className="h1">150+</span>
              <span className="span">Professional Drivers</span>
            </p>
          </li>

          <li>
            <p className="card-text">
              <span className="h1">100+</span>
              <span className="span">Cities Served</span>
            </p>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default Stats;
